<template>
  <div>
    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Dessinez votre campagne</h2>
            <p class="lead text-white">
              Décrivez nous vos besoins et nous vous proposerons de belles
              campagnes pour booster la visibilité de votre entreprise et de vos
              activités.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 section-contact-us">
      <div class="container">
        <div class="row justify-content-center mt--300">
          <div class="col-lg-8">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <!--                            <h4 class="mb-1">Want to work with us?</h4>-->
              <!--                            <p class="mt-0">Your project is very important to us.</p>-->
              <base-input
                class="mt-5"
                v-model="nom"
                alternative
                placeholder="Nom complet*"
                addon-left-icon="ni ni-single-02"
              >
              </base-input>

              <base-input
                class=""
                v-model="entreprise"
                alternative
                placeholder="Nom de votre entreprise*"
                addon-left-icon="ni ni-briefcase-24"
              >
              </base-input>

              <base-input
                v-model="contact"
                alternative
                placeholder="Contact* (+229 40361453)"
                addon-left-icon="ni ni-mobile-button"
                @keypress="isNumberOnly"
              >
              </base-input>
              <base-input
                v-model="email"
                alternative
                placeholder="Email*"
                type="email"
                addon-left-icon="ni ni-email-83"
              >
              </base-input>

              <base-input class="mb-4">
                <textarea
                  v-model="description"
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="Vos besoins *"
                >
                </textarea>
              </base-input>

              <div
                class="text-center mt-2 mb-4 error p-4"
                v-if="error !== null"
              >
                {{ error }}
              </div>

              <div
                v-if="bouton !== 'default'"
                class="mt-2 mb-4 text-center successForm p-4"
              >
                Votre demande a bien été enregistrée. Nous vous contacterons
                dans les prochaines heures pour la suite.
              </div>

              <base-button type="default" round block size="lg" @click="save">
                <span v-if="charge === false" class="text-white">Envoyer</span>
                <scale-loader
                  v-if="charge === true"
                  :color="loaderColor"
                  class="text-center"
                />
              </base-button>
            </card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { db } from "@/main";
import ScaleLoader from "vue-spinner/src/PulseLoader";
import axios from "axios";

export default {
  name: "home",
  components: { ScaleLoader },
  data() {
    return {
      nom: "",
      contact: "",
      email: "",
      description: "",
      entreprise: "",
      charge: false,
      loaderColor: "#fff",
      bouton: "default",
      error: null,
    };
  },
  methods: {
    isNumberOnly($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 42 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    sendEmail() {
      const data = {
        service_id: "service_kayucwf",
        template_id: "template_cb7pzdo",
        user_id: "O9da8WnRYir8ow9G9",
        template_params: {
          username: this.nom,
          email: this.email,
          phone: this.contact,
          autreInfo: this.description,
          entreprise: this.entreprise,
        },
      };

      axios
        .post("https://api.emailjs.com/api/v1.0/email/send", data)
        .then(
          (result) => {
            console.log("SUCCESS!", result.text);
            this.nom = "";
            this.entreprise = "";
            this.contact = "";
            this.email = "";
            this.description = "";
          },
          (error) => {
            console.log("FAILED...", error.text);
          }
        )
        .catch((error) => {
          console.log(error);
        });
    },

    save() {
      this.error = null;
      if (
        this.nom.length > 0 &&
        this.contact.length > 0 &&
        this.entreprise.length > 0 &&
        this.email.length > 0 &&
        this.description.length > 0
      ) {
        this.charge = true;
        this.sendEmail();

        const createdat = new Date().getTime();
        let id = db.collection("campagnes").doc();
        id.set({
          id: id.id.toString(),
          createdAt: createdat,
          fullName: this.nom,
          email: this.email,
          phone: this.contact,
          description: this.description,
          isRead: false,
        })
          .then((response) => {
            this.charge = false;
            this.bouton = "green";
          })
          .catch((error) => {
            this.charge = false;
            console.error("Error writing document: ", error);
          });
      } else {
        this.error = "Veuillez remplir les cahmps obligatoires pour continuer";
      }
    },
  },
};
</script>
<style>
.successForm {
  color: #2dce89;
  background-color: #d7f5ec;
}
.error {
  color: #f5140c;
  background-color: #f5dad7;
}
</style>
